import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

export const sauterTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: '#6911DF', // Sauter Purple
    },
    secondary: {
      main: '#BAEF26', // Sauter Lime
    },
    navigation: {
      background: '#6911DF', // Sidebar Roxo
      indicator: '#BAEF26',
      color: '#FFFFFF',
      selectedColor: '#BAEF26',
    },
    background: {
      default: '#FFFFFF', // Área principal Branca
      paper: '#FFFFFF',
    },
    text: {
      primary: '#15032D',
      secondary: '#585858',
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#6911DF', '#15032D'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#6911DF', '#15032D'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#6911DF', '#15032D'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#6911DF', '#15032D'],
      shape: shapes.wave,
    }),
    tool: genPageTheme({ colors: ['#6911DF', '#15032D'], shape: shapes.wave }),
    other: genPageTheme({ colors: ['#6911DF', '#15032D'], shape: shapes.wave }),
  },
});
